import React from 'react';
import Footer from '../../components/Layout/Footer';
import Header from '../../components/Layout/Header/Header';

export default function PrivacyPolicy() {
  return (
    <div className="template-index index-demo4">
      <div className="page-wrapper">
        <div className="classic-topHeader">
          <Header />
          <div id="page-content" className="mb-0">
            <div className="container mt-5 mb-5" style={{ minHeight: '50vh' }}>
              <h1 className="text-center mb-4">PRIVACY POLICY</h1>
              <div className="policy-content" style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.8' }}>
                <h4 className="mt-4 mb-2">Introduction</h4>
                <p>
                  This privacy policy covers the practices for handling and securing your personal information by <strong>ADCASTER</strong> (hereinafter referred to as "Adcaster"). The domain name <strong>www.adcaster.in</strong> (hereinafter referred to as the "Website"), is owned and operated by Adcaster, having its registered office/shop at <strong>Kottakkal, Malappuram District, Kerala, India</strong>.
                </p>
                <p>
                  This Privacy Policy applies to persons who purchase or rent any product, equipment, or services from Adcaster through any channel (website, mobile site, telephone order, or offline store visits). By accessing or using our services, you agree to the terms of this Privacy Policy.
                </p>
                <h4 className="mt-4 mb-2">Collection of Personal Info</h4>
                <p>
                  For availing rental services/products from Adcaster, you may need to sign up and provide personal information such as your email address, full name, phone number, address, and valid official identity verification documents (such as an original Aadhaar card or Driving License). Some of this information is collected strictly for identity verification, equipment security, and compliance with our rental agreements.
                </p>
                <p>
                  We use your contact information (including phone/WhatsApp numbers) to send booking updates, order confirmations, offers, and promotions. You can browse our website without revealing personal information, though servers may automatically log IP addresses and access times for system administration.
                </p>
                <h4 className="mt-4 mb-2">Use of Cookies</h4>
                <p>
                  Adcaster uses standard cookies to enhance user experience, streamline the booking process, and analyze website traffic. No personally identifiable information (PII) is stored in cookies to be shared with third parties.
                </p>
                <h4 className="mt-4 mb-2">Payment Gateway</h4>
                <p>
                  Electronic transactions entered via the Website are protected by secure encryption technology. We partner with secure payment gateways (e.g., Razorpay / UPI Gateways). Adcaster does not store or access your sensitive financial data like card numbers or banking PINs.
                </p>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
